/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import DynamicReducer from '../DynamicReducer'
import Context from './Context'

class DynamicReducerProvider extends React.Component {

    constructor(props) {
        super(props)
        // Initialize the provided DynamicReducer
        this.props.dynamicReducer.setDispatch(this.props.dispatch)
    }

    render() {
        return (
            <Context.Provider value={this.props.dynamicReducer}>
                {this.props.children ? React.Children.only(this.props.children) : null}
            </Context.Provider>
        )
    }
}

DynamicReducerProvider.propTypes = {
    dynamicReducer: PropTypes.instanceOf(DynamicReducer).isRequired
}

export default connect()(DynamicReducerProvider)
